$(document).ready(function () {
    $('br').attr('aria-hidden','true'); 
    $('hr').attr('aria-hidden','true');

    $('a#back-to-top').on('click', function(e) {
      e.preventDefault();
      setTimeout(() => {
      $('#back-btn').focus();      
      }, 500);
    }); 

})

// adding label to the links
$(document).ready(function() {
  
  var $button = $('a.button.button--primary[href="/collections/premiere-stainless-collection"]');
  
  // Apply the label
  $button.attr('aria-label', 'Shop the Premiere Stainless Collection');

  var $learnMoreLink = $('a.button[href="/pages/certified-refurbished-1"]');
  
  // Apply a descriptive aria-label to give context to screen readers
  $learnMoreLink.attr('aria-label', 'Learn more about our certified refurbished products');

});

// empty Headings
$(document).ready(function() {
    $('h1, h2, h3, h4, h5, h6').filter(function() {
      return $(this).text().replace(/\s+/g, '') === '' && 
             $(this).children().length === 0;
    }).remove();
});


// Social and External link warning Fixed
$(document).ready(function() {
    const currentHost = window.location.hostname.replace('www.', '');
    const warningText = " Redirecting to a third-party website, opens in a new tab.";
  
    $('a[href^="http://"], a[href^="https://"]').each(function() {
      const $link = $(this);
      const linkHost = this.hostname.replace('www.', '');
  
      if (linkHost === currentHost || !linkHost) return; // Skip internal links
  
      // Get text or fallback from image alt
      let linkText = $link.text().trim();
      if (!linkText) {
        const imgAlt = $link.find('img').attr('alt');
        linkText = imgAlt ? imgAlt.trim() : linkHost;
      }
  
      // Build aria-label
      const currentAriaLabel = $link.attr('aria-label');
      const newLabel = currentAriaLabel 
        ? `${currentAriaLabel}${warningText}` 
        : `${linkText}${warningText}`;
  
      // Apply attributes
      $link.attr({
        'aria-label': newLabel,
        'target': '_blank',
        'rel': 'noopener noreferrer nofollow'
      });
  
    });
});


// Email Label to all Email Address
$(document).ready(function() {
    $('a[href^="mailto:"]').each(function() {

      let email = $(this).attr('href').replace('mailto:', '').trim();

      email = decodeURIComponent(email)
              .split('?')[0]
              .split('&')[0];
      
      $(this).attr('aria-label', 'Email Address: ' + email);
    });
});

// Phone Label to all Phone Number
$(document).ready(function() {
    $('a[href^="tel:"]').each(function() {
      const $link = $(this);
      const visibleText = $link.text().trim();
      const existingLabel = $link.attr('aria-label') || '';
  
      // Only add if not already present
      if (!existingLabel.includes('Phone Number')) {
        const newLabel = `Phone Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
        $link.attr('aria-label', newLabel);
      }
    }); 
}); 

// Gallery 
$(document).ready(function () {

  function updateGalleryAria() {
      $('.product__media-list').each(function () {

          const $slides = $(this).find('.product__media');
          const $selectedSlide = $slides.filter('.selected');

          $slides.each(function (index) {
              const $slide = $(this);

              // If a selected slide exists, use it.
              // Otherwise treat the first slide as active.
              const isActive = $selectedSlide.length
                  ? $slide.hasClass('selected')
                  : index === 0;

              $slide.attr('aria-hidden', isActive ? 'false' : 'true');
              $slide.attr('aria-current', isActive ? 'true' : 'false');

              // $slide.find('a, button, input, select, textarea').each(function () {
              //     $(this).attr('tabindex', isActive ? '0' : '-1');
              // });
          });
      });
  }

  // Initial load
  updateGalleryAria();

  // Watch for selected class changes
  const galleryObserver = new MutationObserver(function () {
      updateGalleryAria();
  });

  $('.product__media-list').each(function () {
      galleryObserver.observe(this, {
          subtree: true,
          attributes: true,
          attributeFilter: ['class']
      });
  });

});

// Announcement Bar
$(document).ready(function ($) {

  function updateAnnouncementTabindex() {
      $('.announcement__slide').each(function () {
          const $link = $(this).find('a');

          if ($(this).hasClass('is-selected')) {
              // Active announcement → remove tabindex
              $link.removeAttr('tabindex');
          } else {
              // Inactive announcements → prevent focus
              $link.attr('tabindex', '-1');
          }
      });
  }

  // Run on page load
  updateAnnouncementTabindex();

  // Run after Flickity changes slide
  $('.announcement-bar').on('change.flickity', function () {
      updateAnnouncementTabindex();
  });

});

// Click here links label
$(document).ready(function ($) {

  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = "redirecting to a third-party website, opens in new tab.";

  $('a').each(function () {

    const $el = $(this);

    const text = $el.text().trim();
    if (!text) return;

    // Normalize text (handles click here. / click here!)
    const normalized = text
      .toLowerCase()
      .replace(/[.,!?;:]+$/, '')
      .trim();

    // Only target "click here"
    if (normalized === 'click here') {

      const href = $el.attr('href') || '';
      let context = '';
      let isExternal = false;

      try {
        const url = new URL(href, window.location.origin);

        // Check external link
        const linkHost = url.hostname.replace('www.', '');
        if (linkHost && linkHost !== currentHost) {
          isExternal = true;
        }

        // Build context from URL
        context = url.pathname
          .replace(/^\/(pages|products|collections|blogs|policies)\//, '') // remove Shopify prefixes
          .replace(/\/+/g, ' ')
          .replace(/-/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

      } catch (e) {
        context = '';
      }

      // Build label
      let label = 'Click here';

      if (context) {
        label = `Click here to ${context}`;
      }

      // Add external warning
      if (isExternal) {
        label += `, ${warningText}`;
      }

      // Final cleanup
      label = label
        .replace(/\s+/g, ' ')
        .trim();

      // Set aria-label
      const existing = $el.attr('aria-label') || '';

      if (!existing || existing.toLowerCase() === 'click here') {
        $el.attr('aria-label', label);
      }

    }

  });

});

// Fix generic "Link" anchor text accessibility
$(document).ready(function ($) {

  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = "redirecting to a third-party website, opens in new tab.";

  $('a').each(function () {

    const $el = $(this);

    // Get visible link text (works even inside span)
    const text = $el.text().trim();

    // Only target exact visible text "Link"
    if (text.toLowerCase() === 'link') {

      const href = $el.attr('href') || '';
      let context = '';
      let isExternal = false;

      try {
        const url = new URL(href, window.location.origin);

        // Check if external link
        const linkHost = url.hostname.replace('www.', '');
        if (linkHost && linkHost !== currentHost) {
          isExternal = true;
        }

        // Try building context from URL path
        context = url.pathname
          .replace(/^\/(pages|products|collections|blogs|policies)\//, '')
          .replace(/\/+/g, ' ')
          .replace(/-/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();

      } catch (e) {
        context = '';
      }

      // Build new label
      let label = context ? `Link to ${context}` : 'Link';

      // External warning
      if (isExternal) {
        label += `, ${warningText}`;
      }

      // Force overwrite existing aria-label
      $el.attr('aria-label', label);
    }

  });

});

//  Homepage tabs
$(document).ready(function () {

  function updateTabAriaSelected() {
      $('[role="tab"]').each(function () {
          $(this).attr('aria-selected', this.disabled ? 'true' : 'false');
      });
  }

  // Set initial state
  updateTabAriaSelected();

  // Watch for changes to the disabled attribute
  $('[role="tab"]').each(function () {
      const observer = new MutationObserver(function () {
          updateTabAriaSelected();
      });

      observer.observe(this, {
          attributes: true,
          attributeFilter: ['disabled']
      });
  });

});

// Header Language Tabs
$(document).ready(function () {

  $(document).on('keydown', '.localization__item > button', function (e) {

      if (e.key === 'Enter' || e.key === ' ') {

          const $button = $(this);

          setTimeout(function () {

              const $firstItem = $button
                  .siblings('dropdown-localization')
                  .find('a:first');

              if ($firstItem.length) {
                  $firstItem.trigger('focus');
              }

          }, 100);
      }

  });

});

// Collection Featured filter
document.querySelectorAll('facet-sort').forEach((facetSort) => {
  const hoverEl = facetSort.querySelector('hover-element');
  const trigger = facetSort.querySelector('.sort-header');

  if (!hoverEl || !trigger) return;

  function isOpen() {
    return hoverEl.hasAttribute('open') || hoverEl.classList.contains('open');
  }

  // 1. aria-expanded always mirrors the open attribute/class
  function syncExpanded() {
    trigger.setAttribute('aria-expanded', String(isOpen()));
  }

  new MutationObserver(syncExpanded).observe(hoverEl, {
    attributes: true,
    attributeFilter: ['open', 'class']
  });

  syncExpanded(); // set correct value immediately on page load

  // 2. Escape closes the dropdown and returns focus to the trigger
  facetSort.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen()) {
      e.preventDefault();
      hoverEl.removeAttribute('open');
      hoverEl.classList.remove('open');
      trigger.focus();
    }
  });
});